<template>
  <div>
    <headerimg></headerimg>
    <div class="oderlist">
      <div class="listcontent">

        <div class="img">
          <img src="../../assets/images/mpesa/icon2.png" alt="">
        </div>
        <h2>Processing payment</h2>
        <p class="tips">Please wait while we confirm your payment status.</p>
      </div>
      <div class="grounp_btn_mpesa">
        <div class="mpesa_btn_left" @click="$router.go(-2)">Cancel</div>
        <div class="mpesa_btn_right">Confirm</div>
      </div>
    </div>

    <emailtext></emailtext>
  </div>
</template>
<script>
  import {encryption} from "../../utils/requestUtils";

  export default {
    data() {
      return {
        List: {
          mobile: '',
          email: ''
        },
        Params: '',
        request_flag: true,
      }
    },
    mounted() {
      this.Params = this.$route.query
      this.getParams()

      // this.payment()
      this.paymentxun()
    },
    methods: {
      getParams() {
        this.List = this.$route.query
        console.log(this.$route)
        console.log(this.List)
      },
      paymentxun() {
        this.axios.post('/api/order/paymentStatus', {
          requestParam: encryption({
            merchantId: this.Params.merchantId,
            merchantOrderId: this.Params.merchantOrderId
          })
        }).then(res => {
          if (res.data.data.status == 0) {
            if (res.data.data.timeoutSeconds <= 0) {
              this.$router.push({
                path: '/mpesa/fail',
                query: this.Params
              })
            } else {
              setTimeout(() => {
                this.paymentxun()
              }, 3000)
            }

            this.UserInfo = res.data.data
          } else if (res.data.data.status == 1) {
            this.$router.push({
              path: '/mpesa/success',
              query: this.Params
            })
          } else if (res.data.data.status == 2) {
            this.$router.push({
              path: '/mpesa/fail',
              query: this.Params
            })

          }


        })
      },
      payment() {
        console.log(this.List)
        if (!this.request_flag) {
          return
        }

        // this.$toast('Payment Proceed')
        this.payBtn = "Payment Proceed";
        const that = this;
        this.request_flag = false
        this.flag = true // 加载中...
        // const sign = localStorage.getItem('sign')
        const timestamp = new Date().getTime()
        const curURL = '/api/order/submitSecond'
        const data = {
          merchantId: that.List.merchantId,
          merchantOrderId: that.List.merchantOrderId,
          amount: that.Params.amount,
          timestamp: timestamp,
          sign: that.List.sign,
          mobile: that.List.mobile,
          email: that.List.email
        }

        this.axios.post(curURL, data).then(res => {
          console.log(res.data.data.status)
          if (res.data.data.status == 0) {
            // 待支付
            this.flag = false
            this.$toast('Your money will be comfirmed in few minutes')
          } else if (res.data.data.status == 1) {
            // this.$toast('Payment success')
            // this.$router.push({path: '/success', query: {'image': this.UserInfo.logoUrl}})
            if (res.data.data.callbackUrl != '' && res.data.data.callbackUrl.startsWith('http')) {
              window.location.href = res.data.data.callbackUrl
            } else {
              this.$router.push({
                path: '/mpesa/success',
                query: this.Params
              })
            }

          } else if (res.data.data.status == 2) {
            // this.$toast('Failure to pay')
            this.$router.push({
              path: '/mpesa/fail',
              query: this.Params
            })
          }
          this.request_flag = true
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .oderlist {
    padding: 0 0.48rem;

    .listcontent {
      background: #FFFFFF;
      border-radius: 0.32rem;

      h2 {
        font-size: 0.4rem;
        font-weight: 800;
        color: #FF6601;
        line-height: 0.66rem;
        padding-bottom: 0.16rem;
      }

      .img {
        img {
          width: 4.22rem;
          margin: 0.8rem auto 0.58rem auto;
        }


      }

      .tips {
        width: 3.26rem;
        font-size: 0.28rem;
        font-weight: 500;
        color: #151515;
        line-height: 0.5rem;
        padding-bottom: 0.56rem;
        text-align: center;
        margin: 0 auto;
      }
    }
  }

  .grounp_btn_mpesa {
    margin: 0.32rem 0;
    display: flex;
    justify-content: space-between;
    line-height: 1rem;
    font-size: 0.3rem;
    font-weight: 800;

    .mpesa_btn_left {
      width: 2rem;
      height: 1rem;
      background: #191932;
      border-radius: 0.16rem;
      color: #FFFFFF;

    }

    .mpesa_btn_right {
      width: 4.24rem;
      height: 1rem;
      background: linear-gradient(133deg, #02BD60 0%, #02B683 32%, #00B39B 100%), linear-gradient(138deg, #8AFFA7 0%, #FEFD42 100%);
      border-radius: 0.16rem;
      color: #151515;
      opacity: 0.5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/mpesa/processing.vue